import {SearchEntity, SearchModel, SearchModelAdapter} from '../entity/search.models';
import {ResponseItemModel} from '../../../../../../../../core';

export class GetResponse extends ResponseItemModel<SearchModel> {
}

export class GetResponseAdapter extends ResponseItemModel<SearchEntity> {
  constructor(response: GetResponse) {
    super();
    this.code = response.code;
    this.extMsg = response.extMsg;
    this.field = response.field;
    this.htmlCode = response.htmlCode;
    this.msg = response.msg;
    this.msgKey = response.msgKey;
    this.rows = response.rows;
    this.value = response.value;
    this.data = new SearchModelAdapter(response.data);
  }
}
